<template>
    <card shadow type="secondary">
        <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-8">
                    <h3 class="mb-0">Eigenen Benutzer editieren</h3>
                </div>
            </div>
        </div>
        <template>
            <form @submit.prevent="editUser($store.getters['authentication/uid'])">
                <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                <h6 class="heading-small text-muted mb-4">Angaben zum Benutzer</h6>
                <userform ref="UForm" :loading-prop="isLoading"/>
                <!-- Address -->
                <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                    <span class="btn-inner--icon"><font-awesome-icon v-if="isLoading" icon="circle-notch" spin></font-awesome-icon><i v-else class="ni ni-fat-add"></i></span>
                    <span class="btn-inner--text">Benutzerdaten ändern</span></button>
            </form>
        </template>
    </card>
</template>

<script>
    import Userform from "@/views/Users/Userform";
    export default {
        name: "profil",
        components: {Userform},
        data() {
            return {
                isLoading: false,
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        created() {
            this.showUser(this.$store.getters['authentication/uid'])
        },
        methods: {
        showUser(id) {
            return new Promise(() => {
                const header = this.authHeader();
                header['Content-Type'] = 'application/json';
                const requestOptions = {
                    method: 'GET',
                    headers: header,
                };
                this.isLoading = true;
                fetch(process.env.VUE_APP_API_SERVER + `/api/users/`+id, requestOptions)
                    .then(this.handleResponse)
                    .then(response => {
                            this.isLoading = false;
                            this.$refs.UForm.user = response;
                            if (typeof response.location !== 'undefined') this.$refs.UForm.user.location = response.location['@id'];
                            if (typeof response.customer !== 'undefined') this.$refs.UForm.user.customer = response.customer['@id'];
                        },
                        error => {
                            this.isLoading = false;
                            this.status =  {type: 'danger', msg: error};
                        });
            });
        },
        editUser(id) {
            return new Promise(() => {
                const header = this.authHeader();
                header['Content-Type'] = 'application/merge-patch+json';
                let senddata = this.$refs.UForm.user;
                delete senddata.UserCustomers;
                delete senddata.UserLocations;
                const requestOptions = {
                    method: 'PATCH',
                    headers: header,
                    body: JSON.stringify(senddata)
                };
                this.isLoading = true;
                fetch(process.env.VUE_APP_API_SERVER + `/api/users/`+id, requestOptions)
                    .then(this.handleResponse)
                    .then(response => {
                            this.isLoading = false;
                            this.status =  {type: 'success', msg: 'Benutzer '+response.firstname+' '+response.lastname+' (ID: '+response.id+') wurde editiert.'};
                            this.$store.dispatch('authentication/onRefresh');
                        },
                        error => {
                            this.isLoading = false;
                            this.status =  {type: 'danger', msg: error};
                        });
            });
        },
        }
    }
</script>

<style scoped>

</style>